import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-99914192"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "closer" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-times" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = {
    type: "button",
    class: "btn btn-green"
};
const _hoisted_6 = {
    key: 2,
    class: "swiper-container",
    ref: "swiper"
};
const _hoisted_7 = { class: "swiper-wrapper" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "swiper-pagination" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_localized_text = _resolveComponent("localized-text");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
            }, _hoisted_4)
        ]),
        (_ctx.zipping)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "my-4 text-center",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.downloadAsZip && _ctx.downloadAsZip(...args)))
            }, [
                _createElementVNode("button", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "Download come zip",
                        text: "Download come zip"
                    })
                ])
            ])),
        (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "swiper-slide",
                            key: i
                        }, [
                            _createElementVNode("div", {
                                class: "imgContainer",
                                style: _normalizeStyle({ 'background-image': _ctx.getBgImage(item.publicUrl) })
                            }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-green",
                                    onClick: ($event) => (_ctx.download(item))
                                }, [
                                    _createVNode(_component_localized_text, {
                                        localizedKey: "Download",
                                        text: "Download"
                                    })
                                ], 8, _hoisted_8)
                            ], 4)
                        ]));
                    }), 128))
                ]),
                _hoisted_9
            ], 512))
            : _createCommentVNode("", true)
    ]));
}
